import { translateTexts as translateTextsApi } from '../api'

const cache = new Map()

function cacheKey(text, locale) {
  return `${locale}::${text}`
}

export async function autoTranslate(text, locale) {
  if (!text || locale === 'zh') return text || ''

  const key = cacheKey(text, locale)
  if (cache.has(key)) return cache.get(key)

  const res = await translateTextsApi([text], locale)
  const translated = res.data.texts[0] || text
  cache.set(key, translated)
  return translated
}

export async function autoTranslateBatch(texts, locale) {
  if (locale === 'zh') return texts

  const results = [...texts]
  const pendingIndexes = []
  const pendingTexts = []

  texts.forEach((text, index) => {
    if (!text || !String(text).trim()) return
    const key = cacheKey(text, locale)
    if (cache.has(key)) {
      results[index] = cache.get(key)
      return
    }
    pendingIndexes.push(index)
    pendingTexts.push(String(text))
  })

  if (!pendingTexts.length) return results

  const res = await translateTextsApi(pendingTexts, locale)
  res.data.texts.forEach((translated, i) => {
    const index = pendingIndexes[i]
    const original = texts[index]
    results[index] = translated || original
    cache.set(cacheKey(original, locale), results[index])
  })

  return results
}

export function clearTranslateCache() {
  cache.clear()
}
